module.exports = __webpack_public_path__ + "static/img/16-北京第五实验学校.0509df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/16-北京第五实验学校.png
// module id = cMiJ
// module chunks = 0